var cartNoteTyping;

validateQty = function (qty) {
  if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
    // We have a valid number!
  } else {
    // Not a number. Default to 1.
    qty = 1;
  }
  return qty;
};

const countryList = {
  AF: "Afghanistan",
  AX: "Aland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo, the Democratic Republic of the",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Cote D'Ivoire",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Curacao",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and Mcdonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran, Islamic Republic of",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea, Democratic People's Republic of",
  KR: "Korea, Republic of",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyan Arab Jamahiriya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macedonia, the Former Yugoslav Republic of",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States of",
  MD: "Moldova, Republic of",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  AN: "Netherlands Antilles",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestinian Territory, Occupied",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  BL: "Saint Barthelemy",
  SH: "Saint Helena",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  CS: "Serbia and Montenegro",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan, Province of China",
  TJ: "Tajikistan",
  TZ: "Tanzania, United Republic of",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viet Nam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.s.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};

let convertShippingAmount = freeShippingBarAmount;
function checkShippingAvailablity() {
  let selectedCountry = Shopify.country;
  let shippingCountriesContainer = $("#shippingcountries");
  if (shippingCountriesContainer.length == 0) {
    shippingCountriesContainer = $("#shippingCountry");
  }
  if (
    shippingCountriesContainer &&
    shippingCountriesContainer.find("option").length > 0
  ) {
    let shippingSelectedCountry = countryList[selectedCountry];
    if (
      shippingCountriesContainer.find(
        'option[value="' + shippingSelectedCountry + '"]'
      ).length > 0
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

// The free-shipping offer applies to Australian delivery only, and its threshold is the
// AUD amount from theme settings (shipping-amount). It is never converted to another currency.
function freeShippingBar(cart) {
  let shippingBarContainer = $("[data-free-shipping-container]");
  const currency = (cart && cart.currency) || (window.Shopify && Shopify.currency && Shopify.currency.active);
  const australianOffer = window.Shopify && Shopify.country === "AU" && currency === "AUD";
  if (!freeShippingBarStatus || !australianOffer) {
    shippingBarContainer.addClass("hidden");
    return false;
  }
  if (shippingBarContainer.length > 0) {
    if (cart.item_count == 0) {
      shippingBarContainer.addClass("hidden");
      return false;
    }
    let cartPrice = cart.total_price;
    let shippending = Shopify.formatMoney(
      convertShippingAmount - cartPrice,
      moneyFormat
    );
    let shippingPercentage = parseFloat(
      (cartPrice * 100) / convertShippingAmount
    ).toFixed(2);
    if (shippingPercentage > 10 && shippingPercentage < 100) {
      shippingPercentage = shippingPercentage - 5;
    } else if (shippingPercentage > 100) {
      shippingPercentage = 100;
    }
    if ($("[data-free-shipping-text]").length > 0) {
      if (shippingPercentage >= 100) {
        $("[data-free-shipping-text]").text(freeShippingBarSuccessText);
      } else {
        $("[data-free-shipping-text]").text(
          freeShippingBarText.replace("||amount||", shippending)
        );
      }
    }

    if ($("[data-free-shipping-bar]").length > 0) {
      $("[data-free-shipping-bar]").css("width", shippingPercentage + "%");
    }
    shippingBarContainer.removeClass("hidden");
  }
}

// Cart reliability: one cart change at a time, lines addressed by key, and a reason
// shown whenever Shopify refuses a change.
var teuCartQueue = Promise.resolve();
function teuQueueCartChange(task) {
  teuCartQueue = teuCartQueue.then(task, task);
  return teuCartQueue;
}
// Customer wording for cart refusals. Shopify's own text is never shown; it is only read to
// pick the right message. context.inCart is how many of the item the cart holds after the
// refusal; context.inventory is the stock the page knows about (both optional).
const TEU_CART_MESSAGES = {
  restocking: "We're restocking this item right now.",
  checkQuantity: "Please check the quantity and try again.",
  giftCardEmail: "Please enter a valid email address for the gift card recipient.",
};
function teuOnlyAvailable(n) {
  return n === 1 ? "Only 1 is available to order right now." : "Only " + n + " are available to order right now.";
}
function teuAllInCart(n) {
  return n === 1 ? "You have the only one available in your cart." : "You have all " + n + " available in your cart.";
}
function teuCartErrorMessage(xhr, fallback, context) {
  context = context || {};
  let json = xhr && xhr.responseJSON;
  if (!json && xhr && xhr.responseText) {
    try { json = JSON.parse(xhr.responseText); } catch (e) { json = null; }
  }
  // Network failures, server errors and pages that aren't JSON keep the "Something interrupted" message.
  if (!xhr || !json || xhr.status === 0 || xhr.status >= 500) return fallback;
  const text = String(json.description || json.message || "").toLowerCase();
  const number = (text.match(/\d+/) || [])[0];
  const n = number === undefined ? null : Number(number);
  const inCart = Number.isFinite(context.inCart) && context.inCart > 0 ? context.inCart : null;
  const inventory = Number.isFinite(context.inventory) && context.inventory > 0 ? context.inventory : null;

  // The item has just become something Shopify won't sell.
  if (/sold out|no longer available|not available|unavailable|cannot find|could not find|does not exist|doesn't exist/.test(text)) {
    return TEU_CART_MESSAGES.restocking;
  }
  // Stock cap: the cart already holds everything available, or more was asked for than is in stock.
  if (/in your cart|due to availability|only add|add more/.test(text)) {
    const allInCart = /in your cart|due to availability|add more/.test(text);
    if (allInCart && (inCart || n)) return teuAllInCart(inCart || n);
    if (n) return teuOnlyAvailable(n);
    if (inventory) return teuOnlyAvailable(inventory);
    return TEU_CART_MESSAGES.checkQuantity;
  }
  // Quantity rules set on the product.
  if (n && /multiple/.test(text)) return "This item is sold in multiples of " + n + ".";
  if (n && /at least|minimum/.test(text)) return "This item is sold in quantities of " + n + " or more.";
  if (n && /maximum|at most|up to|no more than/.test(text)) return "You can order up to " + n + " of this item.";
  return TEU_CART_MESSAGES.checkQuantity;
}
function teuLineQuantity(cart, key, line) {
  const item = key ? cart.items.find(function (i) { return i.key === key; }) : cart.items[line - 1];
  return item ? item.quantity : 0;
}
function teuShowLineError(key, line, message) {
  let slot = key ? $('[data-cart-error-key="' + key + '"]') : $();
  if (!slot.length) slot = $("#cartItemError-" + line + ", #cartDrawerItemError-" + line);
  slot.text(message);
}
function teuReleaseCartRows() {
  $("[data-cart-items], .cart-items-wrapper, .media-link, tr").removeClass("disabled");
}

var favicon = false;

function browserTabNotification() {
  if (browserNotificationStatus) {
    favicon = new Favico({
      animation: "pop",
      bgColor: browserNotificationBg,
      textColor: browserNotificationText,
      type: browserNotificationShape,
    });
  }
}

$(document).ready(function () {
  browserTabNotification();
  if (favicon) {
    favicon.badge(cartItemsCount);
  }
});

$(document).on("keydown", "[name=note]", function (e) {
  clearTimeout(cartNoteTyping);
});

$(document).on("keyup ", "[name=note]", function (evt) {
  var _this = $(this);
  clearTimeout(cartNoteTyping);
  cartNoteTyping = setTimeout(function () {
    var currentVal = _this.val();
    $.ajax({
      url: cartUpdateUrl,
      type: "POST",
      data: { note: currentVal },
      dataType: "json",
      success: function (result) {},
    });
  }, 750);
});

if (isCartPage) {
  // Shipping Estimations
  (function () {
    let activeShippingEstimator = null;
    async function internationalShippingRates(form, options, root) {
      const endpoint = '/api/2026-07/graphql.json';
      const create = 'mutation FreightQuoteCart($input: CartInput!) { cartCreate(input: $input) { cart { id lines(first: 250) { nodes { id } } } userErrors { field message code } } }';
      const query = 'query FreightQuoteRates($id: ID!) { cart(id: $id) { ... @defer { deliveryGroups(first: 10, withCarrierRates: true) { pageInfo { hasNextPage } nodes { deliveryOptions { title handle estimatedCost { amount currencyCode } } } } } } }';
      const clear = 'mutation ClearFreightQuote($cartId: ID!, $lineIds: [ID!]!) { cartLinesRemove(cartId: $cartId, lineIds: $lineIds) { userErrors { message } } }';
      const fields = new FormData(form);
      const country = fields.get('shipping_address[country]');
      const countryCodes = JSON.parse(form.querySelector('[data-shipping-country-codes]').textContent);
      const countryCode = countryCodes[country] || Object.keys(countryList).find(code => countryList[code] === country);
      if (!countryCode) throw new Error('Shipping country code missing');
      const response = await fetch(root + 'cart.js', options);
      if (!response.ok) throw new Error('Cart could not be read');
      const cart = await response.json();
      if (!cart.items.length || cart.items.length > 250) throw new Error('Cart cannot be quoted');
      const attributes = values => Object.entries(values || {}).map(([key, value]) => ({ key, value: String(value) }));
      const input = {
        lines: cart.items.map(item => ({
          merchandiseId: 'gid://shopify/ProductVariant/' + item.variant_id,
          quantity: item.quantity,
          attributes: attributes(item.properties),
          ...(item.selling_plan_allocation ? { sellingPlanId: 'gid://shopify/SellingPlan/' + item.selling_plan_allocation.selling_plan.id } : {})
        })),
        attributes: attributes(cart.attributes),
        discountCodes: [...new Set([
          ...(cart.discount_codes || []).map(discount => typeof discount === 'string' ? discount : discount.code).filter(Boolean),
          ...(cart.cart_level_discount_applications || []).filter(discount => discount.type === 'discount_code').map(discount => discount.title)
        ])],
        buyerIdentity: {
          countryCode,
          deliveryAddressPreferences: [{ deliveryAddress: {
            country, province: fields.get('shipping_address[province]') || '',
            city: fields.get('shipping_address[city]'), address1: fields.get('shipping_address[address1]'),
            zip: fields.get('shipping_address[zip]') || ''
          } }]
        }
      };
      async function graphql(query, variables, signal = options.signal) {
        const response = await fetch(endpoint, {
          method: 'POST', signal, headers: { 'Content-Type': 'application/json', Accept: 'application/json, multipart/mixed' },
          body: JSON.stringify({ query, variables })
        });
        if (!response.ok) throw new Error('Shipping quote request failed');
        const text = await response.text();
        const boundary = response.headers.get('content-type')?.match(/boundary="?([^";]+)/)?.[1];
        const payloads = boundary ? text.split('--' + boundary).flatMap(part => {
          const body = part.split(/\r?\n\r?\n/).slice(1).join('\n\n').trim();
          return body.startsWith('{') ? [JSON.parse(body)] : [];
        }) : [JSON.parse(text)];
        if (payloads.some(payload => payload.errors?.length || payload.incremental?.some(patch => patch.errors?.length))) throw new Error('Shipping quote calculation failed');
        return payloads;
      }
      let quoteCart;
      try {
        const created = (await graphql(create, { input }))[0].data?.cartCreate;
        quoteCart = created?.cart;
        if (!quoteCart || created.userErrors.length) throw new Error('Shipping quote cart failed');
        const payloads = await graphql(query, { id: quoteCart.id });
        if (payloads.some(payload => payload.data?.cart?.deliveryGroups?.pageInfo?.hasNextPage || payload.incremental?.some(patch => patch.data?.deliveryGroups?.pageInfo?.hasNextPage))) throw new Error('Shipping quote has additional delivery groups');
        const groups = payloads.flatMap(payload => [
          ...(payload.data?.cart?.deliveryGroups?.nodes || []),
          ...(payload.incremental || []).flatMap(patch => patch.data?.deliveryGroups?.nodes || [])
        ]);
        let combined = groups[0]?.deliveryOptions.map(option => ({ name: option.title, price: Number(option.estimatedCost.amount), currency: option.estimatedCost.currencyCode })) || [];
        for (const group of groups.slice(1)) {
          combined = combined.flatMap(rate => {
            const option = group.deliveryOptions.find(option => option.title === rate.name && option.estimatedCost.currencyCode === rate.currency);
            return option ? [{ ...rate, price: rate.price + Number(option.estimatedCost.amount) }] : [];
          });
        }
        return combined.map(rate => ({ ...rate, price: rate.price.toFixed(2) }));
      } finally {
        if (quoteCart) {
          const cleanup = new AbortController();
          const timeout = setTimeout(() => cleanup.abort(), 10000);
          await graphql(clear, { cartId: quoteCart.id, lineIds: quoteCart.lines.nodes.map(line => line.id) }, cleanup.signal).catch(() => {});
          clearTimeout(timeout);
        }
      }
    }
    function shippingEstimates() {
      const form = document.getElementById('shippingEstimatesForm');
      if (activeShippingEstimator && activeShippingEstimator.form !== form) activeShippingEstimator.invalidate();
      if (!form || !window.Shopify?.CountryProvinceSelector) return;
      if (form.shippingEstimator) {
        form.shippingEstimator.invalidate();
        return;
      }
      const country = document.getElementById('shippingCountry');
      const province = document.getElementById('shippingProvince');
      const button = document.getElementById('getShippingEstimates');
      const result = document.getElementById('ShippingWrapperResponse');
      const details = form.closest('[data-shipping-estimator]');
      let controller = null, revision = 0;
      new Shopify.CountryProvinceSelector('shippingCountry', 'shippingProvince', {
        hideElement: 'shippingProvinceContainer'
      });

      function invalidate() {
        revision++;
        controller?.abort();
        controller = null;
        button.disabled = false;
        form.setAttribute('aria-busy', 'false');
        result.replaceChildren();
        result.classList.remove('success', 'error');
        result.hidden = true;
      }

      function resetProvince() {
        const hasRegions = province.options.length > 0;
        province.required = hasRegions;
        province.disabled = !hasRegions;
        if (hasRegions) {
          const placeholder = new Option(province.dataset.selectLabel, '', true, true);
          placeholder.disabled = true;
          province.insertBefore(placeholder, province.firstChild);
          province.value = '';
        }
      }

      function updateAddressFields() {
        const international = country.value !== 'Australia';
        form.querySelectorAll('[data-international-address]').forEach(wrapper => {
          wrapper.hidden = !international;
          wrapper.querySelectorAll('input').forEach(input => {
            input.disabled = !international;
            input.required = international;
          });
        });
      }

      function message(text, error = false) {
        const paragraph = document.createElement('p');
        paragraph.className = error ? 'error-text' : 'success-text';
        paragraph.textContent = text;
        result.replaceChildren(paragraph);
        result.classList.toggle('error', error);
        result.classList.toggle('success', !error);
        result.hidden = false;
      }

      function renderRates(rates) {
        if (!rates.length) {
          message(form.dataset.empty);
          return;
        }
        const paragraph = document.createElement('p');
        paragraph.className = 'success-text';
        rates.forEach(rate => {
          if (!Number.isFinite(Number(rate.price))) throw new Error('Invalid shipping price');
          const row = document.createElement('span');
          const label = document.createElement('strong');
          label.textContent = (rate.presentment_name || rate.name) + ': ';
          const currency = rate.currency || activeCurrency;
          row.dataset.shippingRate = rate.price;
          row.dataset.shippingCurrency = currency;
          const price = currency === activeCurrency
            ? Shopify.formatMoney(Math.round(Number(rate.price) * 100), moneyFormat)
            : new Intl.NumberFormat('en-AU', { style: 'currency', currency, currencyDisplay: 'code' }).format(Number(rate.price));
          row.append(label, document.createTextNode(price));
          paragraph.append(row);
        });
        result.replaceChildren(paragraph);
        result.classList.remove('error');
        result.classList.add('success');
        result.hidden = false;
      }

      country.addEventListener('change', () => {
        resetProvince();
        updateAddressFields();
      });
      form.addEventListener('input', invalidate);
      form.addEventListener('change', invalidate);
      details.addEventListener('toggle', () => { if (!details.open) invalidate(); });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        invalidate();
        const currentRevision = revision;
        const requestController = new AbortController();
        controller = requestController;
        const timeout = setTimeout(() => requestController.abort(), 45000);
        const params = new URLSearchParams(new FormData(form)).toString();
        const root = window.Shopify.routes?.root || '/';
        const options = { signal: requestController.signal, headers: { Accept: 'application/json' }, cache: 'no-store' };
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        message(form.dataset.calculating);
        try {
          if (country.value !== 'Australia') {
            const rates = await internationalShippingRates(form, options, root);
            if (currentRevision === revision) renderRates(rates);
            return;
          }
          const prepared = await fetch(root + 'cart/prepare_shipping_rates.json', {
            ...options, method: 'POST', headers: { ...options.headers, 'Content-Type': 'application/x-www-form-urlencoded' }, body: params
          });
          if (!prepared.ok) throw new Error('Shipping preparation failed');
          for (let attempt = 0; attempt < 30; attempt++) {
            if (currentRevision !== revision) return;
            const response = await fetch(root + 'cart/async_shipping_rates.json?' + params, options);
            if (!response.ok) throw new Error('Shipping calculation failed');
            const data = await response.json();
            if (currentRevision !== revision) return;
            if (data !== null) {
              if (!Array.isArray(data.shipping_rates)) throw new Error('Invalid shipping response');
              renderRates(data.shipping_rates);
              return;
            }
            await new Promise(resolve => setTimeout(resolve, 1000));
          }
          throw new Error('Shipping calculation timed out');
        } catch (error) {
          if (currentRevision === revision) message(form.dataset.retry, true);
        } finally {
          clearTimeout(timeout);
          if (currentRevision === revision) {
            controller = null;
            button.disabled = false;
            form.setAttribute('aria-busy', 'false');
          }
        }
      });
      form.shippingEstimator = { invalidate };
      activeShippingEstimator = { form, invalidate };
      resetProvince();
      updateAddressFields();
    }
    setTimeout(function () {
      shippingEstimates();
      $.ajax({
        url: mainCartUrl,
        type: "GET",
        dataType: "json",
        success: function (result) {
          if (result.item_count > 0) {
            freeShippingBar(result);
            upsellCartProducts(result)
          }
        },
      });
    }, 500);
    window.shippingEstimates = shippingEstimates;
  })();
  // Update quantity based on input on change

  changeCartItem = function (line, quantity, key) {
    teuQueueCartChange(function () {
      return new Promise(function (done) {
        teuChangeCartPageItem(line, quantity, key, done);
      });
    });
  };
  function teuChangeCartPageItem(line, quantity, key, done) {
    var params = {
      type: "POST",
      url: cartChangeUrl,
      data: key ? { id: key, quantity: quantity } : { line: line, quantity: quantity },
      dataType: "json",
      success: function (cart) {
        // if (quantity == 0) {
        //     $('[name="updates[]"][data-line="' + line + '"]').closest('tr').remove();
        // }
        if (cart.item_count == 0) {
          emptyCartStatus = true;
          // $('[data-cart-form]').hide();
          // $('[data-cart-empty]').show();
          $("[data-cart-count]").hide();
        } else {
          emptyCartStatus = false;
          cartItemsCount = cart.item_count;
          if (favicon) {
            favicon.badge(cartItemsCount);
          }
          $("[data-cart-count]").show();

          var item = cart.items[line - 1];
          if (item) {
            $('[name="updates[]"][data-line="' + line + '"]').val(
              item.quantity
            );
          }
        }
        cartPageUpdate(cart, done);
      },
      error: function (XMLHttpRequest, textStatus) {
        // Shopify refused the change: re-read the cart, re-render, then explain on that line.
        const fallback = "Something interrupted your cart update. Please try again.";
        jQuery.getJSON(cartUrl, function (cart, textStatus) {
          const message = teuCartErrorMessage(XMLHttpRequest, fallback, { inCart: teuLineQuantity(cart, key, line) });
          cartItemsCount = cart.item_count;
          if (favicon) {
            favicon.badge(cartItemsCount);
          }
          if (cart.item_count == 0) {
            // $('[data-cart-form]').hide();
            // $('[data-cart-empty]').show();
            $("[data-cart-count]").hide();
          } else {
            $("[data-cart-count]").show();

            var item = cart.items[line - 1];
            if (item) {
              $('[name="updates[]"][data-line="' + line + '"]').val(
                item.quantity
              );
            }
          }
          cartPageUpdate(cart, function () {
            teuShowLineError(key, line, message);
            done();
          });
        }).fail(function () {
          teuReleaseCartRows();
          teuShowLineError(key, line, teuCartErrorMessage(XMLHttpRequest, fallback));
          done();
        });
      },
    };
    jQuery.ajax(params);
  }

  $(document).on("click", ".line_item_change", function (evt) {
    evt.preventDefault();
    var $el = $(this),
      line = $el.data("line"),
      parent = $el.closest("tr"),
      $qtySelector = $el.siblings('input[name="updates[]"]'),
      $step = $el.siblings('input[name="updates[]"]').attr('step');
      $("#cartItemError-" + line).html("");
      var qty = parseInt($qtySelector.val().replace(/\D/g, ""));
      parent.addClass("disabled");
      parent.closest("[data-cart-items]").addClass("disabled");
      var qty = validateQty(qty);
      if ($el.hasClass("quantity-up")) {
        qty += parseInt($step);
      } else {
        qty -= parseInt($step);
        if (qty <= 0) qty = 0;
      }
    $qtySelector.val(qty);
    if (line) {
      changeCartItem(line, qty, $el.data("key"));
    }
  });
  $(document).on("change", '[name="updates[]"]', function (evt) {
    evt.preventDefault();
    var $el = $(this),
    line = $el.data("line"),
    parent = $el.closest("tr"),
    qty = parseInt($el.val().replace(/\D/g, ""));
    parent.addClass("disabled");
    parent.closest("[data-cart-items]").addClass("disabled");
    $("#cartItemError-" + line).html("");
    qty = validateQty(qty);
    // Add or subtract from the current quantity
    if (line) {
      changeCartItem(line, qty, $el.data("key"));
    }
  });

  $(document).on("click", ".line_item_remove", function (evt) {
    evt.preventDefault();
    var $el = $(this),
    parent = $el.closest("tr"),
    line = $el.data("line");
    // If it has a data-line, update the cart
    if (line) {
      parent.addClass("disabled");
      parent.closest("[data-cart-items]").addClass("disabled");
      changeCartItem(line, 0, $el.data("key"));
    }
  });
} else {
  // POST to cart/change.js returns the cart in JSON
  changeItem = function (line, quantity, callback, key) {
    teuQueueCartChange(function () {
      return new Promise(function (done) {
        // buildCart accepts a completion callback; other callbacks complete immediately.
        const render = function (cart, after) {
          if (callback === buildCart) buildCart(cart, undefined, undefined, after);
          else { callback(cart); after(); }
        };
        jQuery.ajax({
          type: "POST",
          url: cartChangeUrl,
          data: key ? { id: key, quantity: quantity } : { line: line, quantity: quantity },
          dataType: "json",
          success: function (cart) {
            if (cart.item_count == 0) {
              emptyCartStatus = true;
              $("[data-cart-count]").hide();
            } else {
              emptyCartStatus = false;
              $("[data-cart-count]").show();
            }
            var item = cart.items[line - 1];
            if (item) {
              $(
                '.ajaxcart__qty-num[name="updates[]"][data-line="' + line + '"]'
              ).val(item.quantity);
            }
            render(cart, done);
          },
          error: function (XMLHttpRequest, textStatus) {
            // Shopify refused the change: re-read the cart, re-render, then explain on that line.
            const fallback = "Something interrupted your cart update. Please try again.";
            jQuery.getJSON(cartUrl, function (cart, textStatus) {
              const message = teuCartErrorMessage(XMLHttpRequest, fallback, { inCart: teuLineQuantity(cart, key, line) });
              render(cart, function () {
                teuShowLineError(key, line, message);
                done();
              });
            }).fail(function () {
              teuReleaseCartRows();
              teuShowLineError(key, line, teuCartErrorMessage(XMLHttpRequest, fallback));
              done();
            });
          },
        });
      });
    });
  };

  updateQuantity = function (line, qty, callback, key) {
    isUpdating = true;
    setTimeout(function () {
      changeItem(line, qty, callback, key);
    }, 250);
  };

  function getvaluefromdataattribute(name) {
    return $('input[data-attr="' + name + '"]').val();
  }

  $("#Recipient-Checkbox").click(function () {
    if (!this.checked) {
      $('input[data-attr="' + "email" + '"]').val("");
      $('input[data-attr="' + "name" + '"]').val("");
    }
  });

  if (cartDrawerEnable) {
    // POST to cart/add.js returns the cart in JSON
    $("body").on("click", ".Sd_addProduct", function (evt) {
      evt.preventDefault();
      let submit = $(this);
      // One request at a time per button: a double tap adds once.
      if (submit.data("teuBusy")) return;
      let form = $(this).closest("form");
      // The sticky bar has no quantity of its own: add with the main product form, so the
      // chosen quantity, quantity rules and line options are respected.
      if (submit.hasClass("Sd_addProductSticky")) {
        const mainForm = submit
          .closest("product-info")
          .find('form[data-type="add-to-cart-form"]')
          .filter(function () { return $(this).closest("#yvProductStickyBar").length === 0; })
          .first();
        if (mainForm.length) form = mainForm;
      }
      submit.data("teuBusy", true).attr("aria-disabled", "true");
      if (form.closest(".yv_side_drawer_wrapper").length == 0) {
        focusElement = submit;
      }
      let parentSection = form.closest(".shopify-section");
      var Email = $('input[data-attr="' + "email" + '"]').val();
      $('input[data-attr="' + "email" + '"]').val("");
      $('input[data-attr="' + "name" + '"]').val("");
      parentSection.find(".productErrors").hide().html("");
      submit.addClass("is-loading");
      if (form.closest(".yv_side_drawer_wrapper").length == 0) {
        $("[data-drawer-body]").html(preLoadLoadGif);
        $("body")
          .find("[data-side-drawer]")
          .attr("class", "yv_side_drawer_wrapper");
        $("body").find("[data-drawer-title]").html(cartTitleLabel);
        $("body").find("[data-side-drawer]").attr("id", "mini__cart");
        $("body").find("[data-side-drawer]").addClass("mini_cart");
      }
      params = {
        type: "POST",
        url: cartAddUrl,
        data: form.serialize(),
        dataType: "json",
        success: function (line_item) {
          if (form.closest(".quick-add-popup").length > 0) {
            form.closest(".quick-add-popup")[0].classList.remove('show');
            form.closest("[quick-add-body]")[0].innerHTML = '';
            document.body.classList.remove('quick-add-popup-open');
          }
          if (form.closest(".yv_side_drawer_wrapper").length > 0) {
            $("[data-drawer-body]").html(preLoadLoadGif);
            $("body")
              .find("[data-side-drawer]")
              .attr("class", "yv_side_drawer_wrapper");
            $("body").find("[data-drawer-title]").html(cartTitleLabel);
            $("body").find("[data-side-drawer]").attr("id", "mini__cart");
            $("body").find("[data-side-drawer]").addClass("mini_cart");
          }
          $("body").removeClass("quickview-open");
          $("body").addClass("side_Drawer_open");
          if(document.getElementById('addToCartAlert')){
            document.getElementById('addToCartAlert').play();
          }
          if(hapticFeedbackStatus){
            const canVibrate = window.navigator.vibrate;
            if (canVibrate) window.navigator.vibrate(500);
          }
          jQuery.getJSON(cartUrl, function (cart, textStatus) {
            buildCart(cart, true);
          }).always(function () {
            setTimeout(function () {
              submit.removeClass("is-loading");
            }, 1000);
          });
        },
        error: function (XMLHttpRequest, textStatus) {
          focusElement = "";
          if (typeof errorCallback === "function") {
            errorCallback(XMLHttpRequest, textStatus);
          } else {
            let errorContainer = parentSection.find(".productErrors");
            if (errorContainer.length > 0) {
              const json = XMLHttpRequest.responseJSON || null;
              const giftCardWrapper = form.find('[data-gift-card-box]');
              const show = function (message) {
                // Text only (never HTML), announced to screen readers.
                errorContainer.text(message).attr("role", "alert").show();
              };
              if (json && json.errors && json.errors['email'] && giftCardWrapper.length > 0) {
                show(TEU_CART_MESSAGES.giftCardEmail);
              } else {
                const variantId = String(form.find('[name="id"]').val() || '');
                let inventory = null;
                try {
                  const data = form.closest("product-info").find("[data-teu-availability-data]").first().text();
                  const entry = data ? JSON.parse(data).find(function (v) { return String(v.id) === variantId; }) : null;
                  inventory = entry ? Number(entry.inventory) : null;
                } catch (e) { inventory = null; }
                const fallback = "Something interrupted adding this to your cart. Please try again.";
                jQuery.getJSON(cartUrl, function (cart) {
                  const inCart = cart.items.filter(function (i) { return String(i.variant_id) === variantId; }).reduce(function (n, i) { return n + i.quantity; }, 0);
                  show(teuCartErrorMessage(XMLHttpRequest, fallback, { inCart: inCart, inventory: inventory }));
                }).fail(function () {
                  show(teuCartErrorMessage(XMLHttpRequest, fallback, { inventory: inventory }));
                });
              }
            }
          }
          $(".Sd_addProductSticky").removeClass("is-loading");
          submit.removeClass("is-loading");
        },
        complete: function () {
          submit.removeData("teuBusy").removeAttr("aria-disabled");
        },
      };
      jQuery.ajax(params);
    });

    // Update quantity based on input on change

    $(document).on("click", ".quantity-button", function (evt) {
      evt.preventDefault();
      var $el = $(this),
      parent = $el.closest(".media-link"),
      line = $el.data("line"),
      $qtySelector = $el.closest(".quantity").find(".ajaxcart__qty-num"),
      $step = $el.closest(".quantity").find('input[name="updates[]"]').attr('step');
      var qty = $qtySelector.val();
      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      if (qty) {
        qty = parseInt(qty.replace(/\D/g, ""));
      }
      var qty = validateQty(qty);
      // Add or subtract from the current quantity
      if ($el.hasClass("ajaxcart__qty--plus")) {
        qty += parseInt($step);
      } else {
        qty -= parseInt($step);
        if (qty <= 0) qty = 0;
      }
      $qtySelector.val(qty);
      if (line) {
        updateQuantity(line, qty, buildCart, $el.data("id"));
      }
    });

    // Update quantity based on input on change
    $(document).on("change", ".ajaxcart__qty-num", function (evt) {
      evt.preventDefault();
      var $el = $(this),
      parent = $el.closest(".media-link"),
      line = $el.data("line"),
      qty = parseInt($el.val().replace(/\D/g, ""));
      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      var qty = validateQty(qty);
      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty, buildCart, $el.data("id"));
      }
    });

    function openCartDrawer(element) {
      $("[data-drawer-body]").html(preLoadLoadGif);
      $("body").find("[data-drawer-title]").html(cartTitleLabel);
      $("body")
        .find("[data-side-drawer]")
        .attr("class", "yv_side_drawer_wrapper");
      $("body")
        .find("[data-side-drawer]")
        .attr("id", "mini__cart")
        .addClass("mini_cart");
      $("body").addClass("side_Drawer_open");
      jQuery.getJSON(cartUrl, function (cart, textStatus) {
        buildCart(cart, true, element);
      });
    }
    $("body").on("click", ".openCartDrawer", function (e) {
      e.preventDefault();
      openCartDrawer($(this));
    }); 

    $("body").on("keydown", ".openCartDrawer", function (e) {
      if (e.code.toUpperCase() === "SPACE") {
        e.preventDefault();
        openCartDrawer($(this));         
      }
    });

    $(document).on("click", ".sd_mini_removeproduct", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = parseInt($el.attr("data-line"));
      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, 0, buildCart, $el.data("id"));
      }
    });

    $(document).on("click ", ".cartDrawerNote", function (evt) {
      $(this).toggleClass("active");
      var textArea = $(this).siblings(".cartNoteContainer");
      textArea.slideToggle();
    });
  }
}

$("body").on("click", "#GiftWrapProduct", function () {
  params = {
    type: "POST",
    url: cartAddUrl,
    data: { id: parseInt($(this).attr("data-product")), quantity: 1 },
    dataType: "json",
    success: function (line_item) {
      jQuery.getJSON(cartUrl, function (cart, textStatus) {
        if (isCartPage) {
          cartPageUpdate(cart);
        } else {
          buildCart(cart, true);
        }
      });
    },
    error: function (XMLHttpRequest, textStatus) {
      jQuery.getJSON(cartUrl, function (cart, textStatus) {
        if (isCartPage) {
          cartPageUpdate(cart);
        } else {
          buildCart(cart, true);
        }
      });
    },
  };
  jQuery.ajax(params);
});

cartPageUpdate = function (cart, done) {
  $.ajax({
    url: mainCartUrl,
    type: "GET",
    dataType: "html",
    error: function () {
      // The cart could not be re-read: leave the page usable rather than greyed out.
      teuReleaseCartRows();
      if (typeof done === "function") done();
    },
    success: function (result) {
      $("body")
        .find("[data-cart-wrapper]")
        .html($(result).find("[data-cart-wrapper]").html());
      window.TEUAgeConfirmation?.refresh(cart);
      $(".cart-section").find("a:first").trigger("focus");
      freeShippingBar(cart);
     upsellCartProducts(cart)
      window.shippingEstimates();
      if (animationStatus) {
        if (AOS) {
          AOS.refreshHard();
        }
      }
      if (typeof done === "function") done();
    },
  });
};

buildCart = function (cart, showCart, element, done) {
  if (cart.item_count === 0) {
    emptyCartStatus = true;
    $("[data-cart-count]").hide();
  } else {
    emptyCartStatus = false;
    $("[data-cart-count]").show();
  }
  cartItemsCount = cart.item_count;
  if(cartItemsCount > 0 && cartItemsCount < 100){
  $('[data-cart-count]').text(cart.item_count);
  }
  else{
    $('[data-cart-count]').text('');
  }
  if (favicon) {
    favicon.badge(cartItemsCount);
  }
  $("[data-drawer-body]").load(mainCartUrl + "?view=jsonData", function (response, status) {
    if (status === "error") {
      // The drawer could not be re-read: keep its current lines usable.
      teuReleaseCartRows();
      if (typeof done === "function") done();
      return;
    }
    window.TEUAgeConfirmation?.refresh(cart);
    freeShippingBar(cart);
     upsellCartDrawerProducts(cart,'drawer')
    setTimeout(function () {
      if($("body").hasClass("yv_side_Drawer_open")){
        $("[data-drawer-side-header]").closest(".yv-upsell-drawer").addClass("active");
      }
    }, 1500);
    if (showCart) {
      $("body").addClass("yv_side_Drawer_open");
      $(".wrapper-overlay").css({ display: "block" });
      focusElementsRotation($("[data-side-drawer]"));
      if (element) {
        focusElement = element;
      }
      $(document).find(".yv_side_drawer_wrapper").trigger("focus");
    }
    if (animationStatus) {
      if (AOS) {
        AOS.refreshHard();
      }
    }
    if (typeof done === "function") done();
  });
};

$(document).on("click","[data-drawer-side-header]",function(){
  $(this).closest(".yv-upsell-drawer").toggleClass('active');
});

function upsellCartDrawerProducts(cart) {
  if(cart.item_count != 0){
    if(document.querySelector("[data-drawer-side-content]")){
      let upsellContainer=document.querySelector("[data-drawer-side-content]");
      let intent=upsellContainer.getAttribute("data-related-products");
      if(intent != "product-list"){
        let productId=cart.items[0].product_id; 
        let limit=upsellContainer.getAttribute("data-limit");
        fetch(window.Shopify.routes.root + "recommendations/products?product_id="+productId+"&limit="+limit+"&section_id=upsell-products&intent="+intent)
         .then(response => response.text())
         .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('#product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
               upsellContainer.innerHTML = recommendations.innerHTML;
                document.querySelector(".yv-upsell-drawer").classList.remove('hidden')
            }else{
              document.querySelector(".yv-upsell-drawer").classList.add('hidden')
            }
         });
      }
      else{
        if(upsellContainer.children.length > 0){
          document.querySelector(".yv-upsell-drawer").classList.remove('hidden')
        }
        else{
          document.querySelector(".yv-upsell-drawer").classList.add('hidden')
        }
      }
    }  
  }
}

function upsellCartProducts(cart) {
  if(cart.item_count != 0){
    if(document.querySelector("[data-cart-upsell-wrapper]")){
      let upsellWrapper=document.querySelector("[data-cart-upsell-wrapper]");
      let upsellContainer=upsellWrapper.querySelector("[data-cart-upsell]");
      let intent=upsellWrapper.getAttribute("data-related-products");
      if(intent != "product-list"){
        let productId=cart.items[0].product_id; 
        let limit=upsellWrapper.getAttribute("data-limit");
        fetch(window.Shopify.routes.root + "recommendations/products?product_id="+productId+"&limit="+limit+"&section_id=upsell-products&intent="+intent)
         .then(response => response.text())
         .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('#product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              if(window.innerWidth >= 768 ){
                if(upsellContainer.classList.contains('flickity-enabled')){
                  let slider = Flickity.data(upsellContainer);
                  if(slider){
                    slider.destroy();
                     upsellContainer.innerHTML = recommendations.innerHTML;
                    upsellWrapper.classList.remove('hidden')
                    flickitySlider(jQuery(upsellContainer));
                  }
                }
                else{
                  upsellContainer.innerHTML = recommendations.innerHTML;
                  upsellWrapper.classList.remove('hidden')
                  flickitySlider(jQuery(upsellContainer));
                }
              }
              else{
                upsellContainer.innerHTML = recommendations.innerHTML;
                upsellWrapper.classList.remove('hidden')
              }
            }else{
              upsellWrapper.classList.add('hidden')
            }
         });
      }
      else{
        if(upsellContainer.classList.contains('flickity-enabled')){
            let slider = Flickity.data(upsellContainer);
            if(slider){
              slider.destroy();
            }
        }
        if(upsellContainer.children.length > 0){
          if(window.innerWidth >= 768 ){
              upsellWrapper.classList.remove('hidden')
              flickitySlider(jQuery(upsellContainer));
          }
          else{
              upsellWrapper.classList.remove('hidden')
          }
        }
        else{
          upsellWrapper.classList.add('hidden')
        }
      }
    }  
  }
}
